<eda-dialog2 [display]="display"
  header="Añadir vista" i18n-header="@@ViewDatamodel" width="50vw" height="70vh"
  [disableApply]="!ok"
  (apply)="onApply()"
  (close)="onClose()">

  <div content> 
    <form [formGroup]="form" class="grid space-y-5">
      <div class="">
        <label for="name" class="font-medium" i18n="@@name">Name <span class="text-red-500">*</span></label>
        <input
          id="name"
          type="text"
          formControlName="viewName"
          placeholder="Introduzca el nombre de la vista"
          i18n-placeholder="@@viewName"
          class="view-input w-full border rounded-md p-2"
        />
      </div>

      <div class="">
        <label for="description" class="font-medium" i18n="@@inputDescripcion">Description</label>
        <input
          id="description"
          type="text"
          formControlName="description"
          placeholder="Enter a brief description"
          i18n-placeholder="@@viewDescription"
          class="view-input w-full border rounded-md p-2"
        />
      </div>

      <div class="">
        <label for="technicalName" class="font-medium" i18n="@@inputNombreTecnico" >Technical Name</label>
        <input
          id="technicalName"
          type="text"
          formControlName="technical_name"
          placeholder="Enter technical identifier"
          i18n-placeholder="@@viewTNameP"
          class="view-input w-full border rounded-md p-2"
        />
      </div>

      <div class="">
        <label for="sqlExpression" class="font-medium" i18n="@@sqlExpColumn">SQL Expression</label>
        <textarea
          id="sqlExpression"
          formControlName="SQLexpression"
          rows="5"
          i18n-placeholder="@@enterSQLExpression"
          placeholder="'Enter your SQL query here'"
          class="view-input w-full border rounded-md p-2 font-mono text-sm"
        ></textarea>
      </div>

      <div>
        <button
          type="button"
          class="view-btn w-full sm:w-auto bg-gray-200 text-black rounded-md px-4 py-2 transition-colors"
          [disabled]="isGenerating"
          (click)="checkView()"
        >
         {{ isGenerating ? generateText.generating : generateText.generate }}
        </button>
      </div>
    </form>
  </div>
</eda-dialog2>

